import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import SubscriptionExpired from './components/SubscriptionExpired';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import WhatsAppInteraction from './components/WhatsAppInteraction';
import BetaBenefits from './components/BetaBenefits';
import BetaForm from './components/BetaForm';
import CorrespondentePage from './components/CorrespondentePage';
import CorretoresPage from './components/CorretoresPage';
import InvestidoresPage from './components/InvestidoresPage';
import BlogPage from './components/BlogPage';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import SuccessPage from './components/SuccessPage';
import PropertySearch from './components/PropertySearch';
import Onboarding from './components/Onboarding';
import PropertyAnalyzer from './components/PropertyAnalyzer';
import ViabilityCalculator from './components/ViabilityCalculator';

function App() {
  const isSuccessPage = window.location.pathname === '/success';
  const isAuthPath = window.location.pathname.startsWith('/app');

  if (isSuccessPage) {
    return <SuccessPage />;
  }

  if (isAuthPath) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/app/*" element={
            <AuthGuard>
              <div className="min-h-screen bg-slate-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <Routes>
                    <Route path="/" element={<PropertySearch />} />
                    <Route path="/onboarding" element={<Onboarding />} />
                    <Route path="/analysis" element={<PropertyAnalyzer />} />
                    <Route path="/calculator" element={<ViabilityCalculator />} />
                  </Routes>
                </main>
              </div>
            </AuthGuard>
          } />
          <Route path="/subscription-expired" element={<SubscriptionExpired />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 text-slate-800">
            <Header />
            <main>
              <Hero />
              <HowItWorks />
              <WhatsAppInteraction />
              <BetaBenefits />
              <FAQ />
              <BetaForm />
            </main>
            <Footer />
          </div>
        } />
        <Route path="/correspondente-bancario" element={<CorrespondentePage />} />
        <Route path="/corretores-imobiliarios" element={<CorretoresPage />} />
        <Route path="/investidores" element={<InvestidoresPage />} />
        <Route path="/blog" element={<BlogPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;